/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MerchantNames_storeLists$ref = any;
export type DeleteMerchantNameInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteMerchantNameMutationVariables = {|
  input: DeleteMerchantNameInput,
  storeId: string,
|};
export type deleteMerchantNameMutationResponse = {|
  +deleteMerchantName: ?{|
    +destroyedMerchantNameId: string,
    +storeLists: {|
      +$fragmentRefs: MerchantNames_storeLists$ref
    |},
  |}
|};
export type deleteMerchantNameMutation = {|
  variables: deleteMerchantNameMutationVariables,
  response: deleteMerchantNameMutationResponse,
|};
*/


/*
mutation deleteMerchantNameMutation(
  $input: DeleteMerchantNameInput!
  $storeId: ID!
) {
  deleteMerchantName(input: $input) {
    destroyedMerchantNameId
    storeLists {
      ...MerchantNames_storeLists
      id
    }
  }
}

fragment MerchantNames_storeLists on StoreLists {
  id
  merchantNames(storeId: $storeId) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMerchantNameInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedMerchantNameId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMerchantNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMerchantNamePayload",
        "kind": "LinkedField",
        "name": "deleteMerchantName",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MerchantNames_storeLists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMerchantNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteMerchantNamePayload",
        "kind": "LinkedField",
        "name": "deleteMerchantName",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "storeId",
                    "variableName": "storeId"
                  }
                ],
                "concreteType": "MerchantName",
                "kind": "LinkedField",
                "name": "merchantNames",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteMerchantNameMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMerchantNameMutation(\n  $input: DeleteMerchantNameInput!\n  $storeId: ID!\n) {\n  deleteMerchantName(input: $input) {\n    destroyedMerchantNameId\n    storeLists {\n      ...MerchantNames_storeLists\n      id\n    }\n  }\n}\n\nfragment MerchantNames_storeLists on StoreLists {\n  id\n  merchantNames(storeId: $storeId) {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ec98c4b2487c981fe753c5a592465ad5';

module.exports = node;
